import { CheckboxDataGroup } from "components/components/CheckboxList/CheckboxList";

type CheckboxGroupChild = {
  name: string;
  datasets: string[];
};

export type CheckboxGroupParent = {
  name: string;
  datasets?: string[];
  children?: CheckboxGroupChild[];
};

/**
 * Flattens a nested hierarchy of checkbox groups into a flat array with sequential IDs.
 */
export const flattenCheckboxDataGroups = (
  checkboxDataGroups: CheckboxGroupParent[]
): CheckboxDataGroup[] => {
  let id = 0;

  return checkboxDataGroups.flatMap((parent) => {
    const parentId = id++;

    return [
      {
        id: parentId,
        name: parent.name,
        parentId: null,
        datasets: parent.datasets,
      },
      ...(parent.children?.map((child) => ({
        id: id++,
        name: child.name,
        parentId: parentId,
        datasets: child.datasets,
      })) || []),
    ];
  });
};
